import React from 'react';
import { Avatar, Stack, Tooltip, Typography } from '@mui/material';
import { IAdminAuditUser } from '../Interfaces/IAdminAudit';
import { useAuthenticatedImage } from '../hooks/useAuthenticatedImage';

interface CompactUserDisplayProps {
    user: IAdminAuditUser | null | undefined;
    size?: number;
}

const toInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0].slice(0, 1).toUpperCase();
    }
    return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`.toUpperCase();
};

const CompactUserDisplay: React.FC<CompactUserDisplayProps> = ({ user, size = 28 }) => {
    const { src } = useAuthenticatedImage(user?.avatarUrl);

    if (!user) {
        return <Typography variant="body2" color="text.secondary">-</Typography>;
    }

    return (
        <Tooltip title={user.displayName}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                <Avatar src={src} sx={{ width: size, height: size }}>
                    {!src ? toInitials(user.displayName) : null}
                </Avatar>
                <Typography variant="body2" noWrap sx={{ maxWidth: 180 }}>
                    {user.displayName}
                </Typography>
            </Stack>
        </Tooltip>
    );
};

export default CompactUserDisplay;
